// assets/min-order-product.js
(function () {
  // ===== FMR CONFIG (edit here) =====
  const CFG = {
  vendorMinRON: {
    nannerl: 2000,
    vecchi: 1500,
  },
  lowStockThreshold: 10,

  badge: {
    minOrderTitle: () => 'Comandă minimă',
    minOrderSubtitle: (vendor, min) =>
      `Adaugă produse de la furnizorul ${vendor}, pănă atingi pragul minim de ${min} RON.`,
  },

  stock: {
    icon: '🏠',
    inStock: 'In stoc',
    lowStock: 'Stoc limitat: {qty} buc.',
    outOfStock: 'Stoc epuizat',
  },
};

  // ==================================
  function getJsonMap(id) {
    const el = document.getElementById(id);
    if (!el) return {};
    try {
      return JSON.parse(el.textContent || '{}');
    } catch {
      return {};
    }
  }

  function normalizeBool(v) {
    // sigur indiferent daca vine true/false sau "true"/"false"
    return v === true || v === 'true' || v === 1 || v === '1';
  }

  function t(tpl, vars) {
    return String(tpl || '').replace(/\{(\w+)\}/g, (_, k) =>
      vars && vars[k] != null ? String(vars[k]) : ''
    );
  }

  function getVendorMinRON(vendor) {
    const key = String(vendor || '').trim().toLowerCase();
    return CFG.vendorMinRON[key] ?? 0;
  }

  function updateMinOrderUI(variantId) {
  const badge = document.querySelector('[data-min-order-badge]');
  const vendor = (badge && badge.getAttribute('data-product-vendor')) ? badge.getAttribute('data-product-vendor') : '';
  const minOrderRON = getVendorMinRON(vendor);
  const dynamicNodes = document.querySelectorAll(
    '.shopify-payment-button, .additional-checkout-buttons, .dynamic-checkout'
  );

  if (!badge && !dynamicNodes.length) return;

  const map = getJsonMap('apply-min-order-variant-map');
  const applyMin = normalizeBool(map[String(variantId)]);

  // Badge: Da/Nu + vizibilitate
  if (badge) {
  // curatam starile vechi
  badge.classList.remove(
    'is-state-minorder',
    'is-state-instock',
    'is-state-low',
    'is-state-oos',
    'min-order-badge--min-order',
    'min-order-badge--no-min-order',
    'is-visible'
  );

  badge.innerHTML = '';

  if (applyMin) {
    badge.innerHTML = `
      <span class="min-order-badge__icon" aria-hidden="true">🧩</span>
      <span class="min-order-badge__content">
        <span class="min-order-badge__title">${CFG.badge.minOrderTitle()}</span>
        <span class="min-order-badge__subtitle">${CFG.badge.minOrderSubtitle(vendor, minOrderRON)}</span>
      </span>
    `;

    badge.classList.add('is-state-minorder');
    badge.classList.add('min-order-badge--min-order');
    badge.classList.add('is-visible');
  } else {
    const availMap = getJsonMap('variant-availability-map');
    const qtyMap = getJsonMap('variant-inventory-qty-map');

    const available = !!availMap[String(variantId)];
    const qtyRaw = qtyMap[String(variantId)];

    // Pentru inventory not tracking, Liquid trimite null.
    // null nu inseamna stoc 0, deci nu afisam badge de stoc.
    if (qtyRaw !== null) {
      const qty = qtyRaw === undefined ? null : Number(qtyRaw);

      let title = '';
      let stateClass = '';

      if (!available) {
        title = CFG.stock.outOfStock;
        stateClass = 'is-state-oos';
      } else if (qty !== null && qty > 0 && qty < CFG.lowStockThreshold) {
        title = t(CFG.stock.lowStock, { qty });
        stateClass = 'is-state-low';
      } else {
        title = CFG.stock.inStock;
        stateClass = 'is-state-instock';
      }

      badge.innerHTML = `
        <span class="min-order-badge__icon" aria-hidden="true">${CFG.stock.icon}</span>
        <span class="min-order-badge__content">
          <span class="min-order-badge__title">${title}</span>
        </span>
      `;

      badge.classList.add(stateClass);
      badge.classList.add('min-order-badge--no-min-order');
      badge.classList.add('is-visible');
    }
  }
}

  // Hide/Show Shop Pay
  dynamicNodes.forEach((n) => {
    n.style.display = applyMin ? 'none' : '';
  });
}

  function getMainRoot() {
    return document.querySelector('product-info') || document;
  }

  function getSelectedVariantInput(root) {
    return root.querySelector('form[action*="/cart/add"] input[name="id"]');
  }

  function getSelectedVariantIdFallback(root) {
    const input = getSelectedVariantInput(root);
    return input ? input.value : null;
  }

  function bind() {
    const root = getMainRoot();

    // 1) initial
    const initialId = getSelectedVariantIdFallback(root);
    if (initialId) updateMinOrderUI(initialId);

    // 2) dropdown-uri clasice
    document.addEventListener('change', (e) => {
      if (e.target && e.target.name === 'id') {
        updateMinOrderUI(e.target.value);
      }
    });

    // 3) event-ul Dawn (cel care iti merge la time-delivery)
    document.addEventListener('variant:change', (e) => {
      const id = e?.detail?.variant?.id;
      if (id) updateMinOrderUI(id);
    });

    document.addEventListener('variantChange', (e) => {
      const id = e?.detail?.variant?.id;
      if (id) updateMinOrderUI(id);
    });

    // 4) fallback “hard”: polling pe value (MutationObserver pe atribut nu ajuta mereu)
    const input = getSelectedVariantInput(root);
    if (input) {
      let last = input.value;
      setInterval(() => {
        if (input.value !== last) {
          last = input.value;
          if (last) updateMinOrderUI(last);
        }
      }, 200);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
